import React from 'react';
import DOMPurify from 'dompurify';

export default function BioContent({ biografie, language }) {
	const { title, content, titleEnglish, contentEnglish } = biografie.fields;
	const html = language ? (content || '') : (contentEnglish || '');
	const sanitized = DOMPurify.sanitize(html, { ALLOWED_TAGS: ['p', 'br', 'strong', 'b', 'em', 'i', 'a', 'ul', 'ol', 'li', 'h2', 'h3'] });

	return (
		<React.Fragment>
			<h2 className="normal-headline">{language ? title : titleEnglish}</h2>
			<div className="bio-text" dangerouslySetInnerHTML={{ __html: sanitized }} />
		</React.Fragment>
	);
}
